var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.9584C5.05817 18.9584 1.0415 14.9417 1.0415 10.0001C1.0415 5.05841 5.05817 1.04175 9.99984 1.04175C14.9415 1.04175 18.9582 5.05841 18.9582 10.0001C18.9582 14.9417 14.9415 18.9584 9.99984 18.9584ZM9.99984 2.29175C5.74984 2.29175 2.2915 5.75008 2.2915 10.0001C2.2915 14.2501 5.74984 17.7084 9.99984 17.7084C14.2498 17.7084 17.7082 14.2501 17.7082 10.0001C17.7082 5.75008 14.2498 2.29175 9.99984 2.29175Z",
    fill: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08337 16.4583C3.92503 16.4583 3.7667 16.4 3.6417 16.275C3.40003 16.0333 3.40003 15.6333 3.6417 15.3916L15.3084 3.72495C15.55 3.48328 15.95 3.48328 16.1917 3.72495C16.4334 3.96662 16.4334 4.36662 16.1917 4.60828L4.52503 16.275C4.40003 16.4 4.2417 16.4583 4.08337 16.4583Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSlash);
export default __webpack_public_path__ + "static/media/circle-slash.89dc21183eb300a8ed33fdafb5a91ba7.svg";
export { ForwardRef as ReactComponent };